import { render, staticRenderFns } from "./CDrugs.vue?vue&type=template&id=22c85eb0"
import script from "./CDrugs.vue?vue&type=script&lang=js"
export * from "./CDrugs.vue?vue&type=script&lang=js"
import style0 from "./CDrugs.vue?vue&type=style&index=0&id=22c85eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports